import { render } from "./edit-verifikasi.vue?vue&type=template&id=7652cada"
import script from "./edit-verifikasi.vue?vue&type=script&lang=js"
export * from "./edit-verifikasi.vue?vue&type=script&lang=js"
script.render = render

export default script